class IPInfoService {
  constructor() {
    this.apiToken = "27f655aff05e14";
    this.baseURL = "https://ipinfo.io";
    this.ipData = null;
    this.initialized = false;
  }

  async init() {
    if (this.initialized) {
      console.log("IPInfo already initialized:", this.ipData);
      return this.ipData;
    }

    try {
      const response = await fetch(
        `${this.baseURL}/json?token=${this.apiToken}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      this.ipData = await response.json();
      this.initialized = true;

      console.log("=== IPInfo Service Initialized ===");
      console.log("IP Address:", this.ipData.ip);
      console.log("City:", this.ipData.city);
      console.log("Region:", this.ipData.region);
      console.log("Country:", this.ipData.country);
      console.log("Location:", this.ipData.loc);
      console.log("Timezone:", this.ipData.timezone);
      console.log("ISP:", this.ipData.org);
      console.log("Postal:", this.ipData.postal);
      console.log("Full Data:", this.ipData);
      console.log("===================================");

      return this.ipData;
    } catch (error) {
      console.error("IPInfo Service Error:", error);
      throw error;
    }
  }

  getData() {
    if (!this.initialized) {
      console.warn("IPInfo not initialized yet. Call init() first.");
      return null;
    }
    return this.ipData;
  }

  getIP() {
    return this.ipData?.ip;
  }

  getCity() {
    return this.ipData?.city;
  }

  getRegion() {
    return this.ipData?.region;
  }

  getCountry() {
    return this.ipData?.country;
  }

  getLocation() {
    return this.ipData?.loc;
  }

  getTimezone() {
    return this.ipData?.timezone;
  }

  getPostal() {
    return this.ipData?.postal;
  }

  // ✨ NEW: Get formatted location for ad matching
  getLocationForAds() {
    if (!this.initialized || !this.ipData) {
      console.warn("IPInfo not initialized. Returning global location.");
      return {
        city: "",
        state: "",
        country: "global",
        zipcode: "",
      };
    }

    return {
      city: this.ipData.city || "",
      state: this.ipData.region || "",
      country: this.ipData.country || "",
      zipcode: this.ipData.postal || "",
      timezone: this.ipData.timezone || "",
      ip: this.ipData.ip || "",
      location: this.ipData.loc || "",
    };
  }

  // Lookup specific IP
  async lookupIP(ip) {
    try {
      const response = await fetch(
        `${this.baseURL}/${ip}/json?token=${this.apiToken}`
      );
      const data = await response.json();
      console.log(`IP Lookup for ${ip}:`, data);
      return data;
    } catch (error) {
      console.error(`Error looking up IP ${ip}:`, error);
      throw error;
    }
  }
}

// Create singleton instance
const ipInfoService = new IPInfoService();

export default ipInfoService;
